"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var PushDetails = /*#__PURE__*/function (_React$Component) {
  _inherits(PushDetails, _React$Component);

  function PushDetails() {
    _classCallCheck(this, PushDetails);

    return _possibleConstructorReturn(this, _getPrototypeOf(PushDetails).apply(this, arguments));
  }

  _createClass(PushDetails, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "credit-card-management"
      }, _react["default"].createElement("div", {
        className: "activated-cards"
      }, _react["default"].createElement("div", {
        className: "dark-blur"
      }), _react["default"].createElement("div", {
        className: "box-header"
      }, _react["default"].createElement("h2", null, _react["default"].createElement("i", {
        className: "fa fa-bell"
      }), " Push Notification Details ")), _react["default"].createElement("div", {
        className: "row",
        style: {
          paddingBottom: 40,
          paddingTop: 40
        }
      }, _react["default"].createElement("div", {
        className: "col-xl-6"
      }, _react["default"].createElement("div", {
        className: "push",
        ref: "element"
      }, _react["default"].createElement("form", {
        action: ""
      }, _react["default"].createElement("label", {
        htmlFor: "title",
        style: {
          color: 'white'
        }
      }, "Push Notification Title"), _react["default"].createElement("input", {
        type: "text",
        value: "Sit back, enjoy your"
      }), _react["default"].createElement("label", {
        htmlFor: "title",
        style: {
          color: 'white'
        }
      }, "Notification type"), _react["default"].createElement("input", {
        type: "text",
        value: "Promotional"
      }), _react["default"].createElement("label", {
        htmlFor: "title",
        style: {
          color: 'white'
        }
      }, "Notification group"), _react["default"].createElement("input", {
        type: "text",
        value: "Group 1"
      }), _react["default"].createElement("label", {
        htmlFor: "title",
        style: {
          color: 'white'
        }
      }, "Date sent"), _react["default"].createElement("input", {
        type: "text",
        value: "02/08/2017"
      }), _react["default"].createElement("label", {
        htmlFor: "title",
        style: {
          color: 'white'
        }
      }, "Notification image"), _react["default"].createElement("img", {
        src: "/img/push-image.png",
        style: {
          maxWidth: '100%'
        }
      }), _react["default"].createElement("label", {
        htmlFor: ""
      }, "Notification Message"), _react["default"].createElement("textarea", {
        name: "",
        id: ""
      }, "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")))), _react["default"].createElement("div", {
        className: "col-xl-6"
      }, _react["default"].createElement("img", {
        src: "/img/push-notification.png",
        alt: "",
        style: {
          maxHeight: '600px',
          display: 'block',
          margin: 'auto'
        }
      })))));
    }
  }]);

  return PushDetails;
}(_react["default"].Component);

exports["default"] = PushDetails;